import { Component } from '@angular/core';
import { KeySlService } from '../services/key-sl.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-gestion-apis',
  templateUrl: './gestion-apis.component.html',
  styleUrls: ['./gestion-apis.component.scss'],
})

export class GestionApisComponent {
  showSecondInput = false; 
  apis: any[] = [];
  apiNew: any[] =[];
  key = '';
  expire: any;
  limite_uso = '';
  searchText = '';
  apisFiltradas: any[] = []; 
  buttonText = 'Ver Token'; 
  isLoading = false;

  constructor(
    private apiKey: KeySlService,
    private snackBar: MatSnackBar
  ){}

  ngOnInit(): void {
    this.loadApis(); 
    console.log(this.apiKey.currentApiKey);
  }
  loadApis(): void {
    this.isLoading = true; 
    let apis2 = [
      {
        nombre: 'OpenCorporate',
        link: 'www.example.com/awesome-link',
        descripcion: 'In a bustling city, a mysterious figure known only as The Seeker roams the',
        activo: true,
      },
      {
        nombre: 'OSINT',
        link: 'www.example.com/awesome-link',
        descripcion: 'In a bustling city, a mysterious figure known only as The Seeker roams the',
        activo: true,
      },
      {
        nombre: 'APIname',
        link: 'www.example.com/awesome-link',
        descripcion: 'In a bustling city, a mysterious figure known only as The Seeker roams the',
        activo: true,
      },
      {
        nombre: 'TrueCaller',
        link: 'www.example.com/awesome-link',
        descripcion: 'In a bustling city, a mysterious figure known only as The Seeker roams the',
        activo: true,
      },
      {
        nombre: 'APIadress',
        link: 'www.example.com/awesome-link',
        descripcion: 'In a bustling city, a mysterious figure known only as The Seeker roams the',
        activo: true,
      },
    ];
    this.apiKey.getApiSocialLinks().subscribe(
      (response: any[]) => {
        // console.log('Respuesta del servicio:', response); 
        this.apis = response; 
         this.apiNew = this.apis.map((objeto, index) => { 
          return {
            ...objeto,
            nombre: apis2[index]?.nombre || 'Nombre no encontrado', 
          };
          
        });
        this.apisFiltradas = this.apiNew;
        // console.log('Respuesta del apis:',  this.apiNew); 
        this.isLoading = false;

      },
      (error) => {
        console.error('Error al cargar las APIs:', error);
        this.showError('Error al cargar las APIs. Inténtalo de nuevo.');
        this.isLoading = false;
      }
    );
  }
  
  filtrarApis(): void {
    if (!this.searchText) {
      this.apisFiltradas = this.apiNew; 
      return;
    }

    const searchTextLower = this.searchText.toLowerCase(); 

    this.apisFiltradas = this.apiNew.filter(
      (api) =>
        api.nombre.toLowerCase().includes(searchTextLower) || 
        api.link.toLowerCase().includes(searchTextLower) || 
        api.descripcion.toLowerCase().includes(searchTextLower) 
    );
  }

  onToggleChange(api: any): void {
    if (!api._id) {
      console.error('El objeto API no tiene un ID válido:', api);
      return;
    }
  
    api.active = !api.active;
    
    console.log('Estado de la API cambiado:', api._id, api.active);
    console.log('la API:', api); 
    
    
    this.apiKey.updateApiSocialLink(api._id, api).subscribe(
      (response) => {
        // console.log('Estado actualizado:', response);
      },
      (error) => {
        console.error('Error al actualizar el estado:', error);
        api.active = !api.active;
      }
    );
  }

  toggleSecondInput() {
    this.showSecondInput = !this.showSecondInput;
    this.buttonText = this.showSecondInput ? 'Ocultar Token' : 'Ver Token';
  }

  guardarToken() {
    if (!this.key || !this.limite_uso || !this.expire) {
      this.showError('Por favor, completa todos los campos.'); // Mensaje de error
      return;
    }

      this.apiKey.createSocialLinksKeys({key:this.key, limite_uso:this.limite_uso, expire:this.expire}).subscribe(
        (response) => {
          // console.log('Key guardado:', response);
        },
        (error) => {
          console.error('Error al crear el key:', error);

        }
      );
      this.showSuccess('Token guardado correctamente.');
    
  }
  showSuccess(message: string): void {
    this.snackBar.open(message, 'Cerrar', {
      duration: 3000, 
      panelClass: ['success-snackbar'], 
    });
  }


  showError(message: string): void {
    this.snackBar.open(message, 'Cerrar', {
      duration: 3000, 
      panelClass: ['error-snackbar'], 
    });
  }

  
}
